import PropTypes from 'prop-types';
import React from 'react';
import StyledButton from './styled';

const IconButton = ({
  children,
  onClick,
  title
}) => /*#__PURE__*/React.createElement(StyledButton, {
  type: "button",
  onClick: onClick,
  title: title
}, children);

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string
};
IconButton.defaultProps = {
  onClick: () => {}
};
export default IconButton;